import StudentKoruAccountBlock from './StudentKoruAccountBlock';
import { StudentKoruAccountBlockProps, StudentKoruAccountBlockValueProps } from './types';

export type { StudentKoruAccountBlockProps, StudentKoruAccountBlockValueProps };
export default StudentKoruAccountBlock;
